export enum EnumEstatusEncuesta {
    Borrador = 1,
    Publicada
}
